const contentTypeJson = "application/json";
const apiAdmin = "/api/admin";
const apiPlan = "/api/plan";
const apiGroup = "/api/group";
const apiProject = "/api/project";
const apiNotification = apiAdmin + "/notification";
const apiPolicy = apiAdmin + "/policy";

const fakeData = function (projectId) {
  return fetch(apiAdmin + "/project/" + projectId + "/fakeData", {
    method: "GET",
    headers: { "Content-Type": contentTypeJson },
  })
    .then(handleResponse)
    .then((data) => {
      return data;
    });
};

const userSearch = function (searchTerm) {
  return fetch(apiAdmin + "/appUser/search", {
    method: "POST",
    headers: { "Content-Type": contentTypeJson },
    body: JSON.stringify({ query: searchTerm }),
  })
    .then(handleResponse)
    .then((data) => {
      return data;
    });
};

const userGet = function (id) {
  return fetch(apiAdmin + "/appUser/" + id, {
    method: "GET",
    headers: { "Content-Type": contentTypeJson },
  })
    .then(handleResponse)
    .then((data) => {
      return data;
    });
};

const userUpdate = function (id, userInfo) {
  return fetch(apiAdmin + "/appUser/" + id, {
    method: "PUT",
    headers: { "Content-Type": contentTypeJson },
    body: JSON.stringify(userInfo),
  })
    .then(handleResponse)
    .then((data) => {
      return data;
    });
};

const userDelete = function (id) {
  return fetch(apiAdmin + "/appUser/" + id + "/delete", {
    method: "GET",
    headers: { "Content-Type": contentTypeJson },
  })
    .then(handleResponse)
    .then((data) => {
      return data;
    });
};

const planSearch = function (searchTerm) {
  return fetch(apiAdmin + "/plan/search", {
    method: "POST",
    headers: { "Content-Type": contentTypeJson },
    body: JSON.stringify({ query: searchTerm }),
  })
    .then(handleResponse)
    .then((data) => {
      return data;
    });
};

const planGet = function (id) {
  return fetch(apiPlan + "/" + id, {
    method: "GET",
    headers: { "Content-Type": contentTypeJson },
  })
    .then(handleResponse)
    .then((data) => {
      return data;
    });
};

const planGetForOuter = function (id) {
  return fetch(apiAdmin + "/plan/" + id, {
    method: "GET",
    headers: { "Content-Type": contentTypeJson },
  })
    .then(handleResponse)
    .then((data) => {
      return data;
    });
};

const planUpdate = function (id, planInfo) {
  return fetch(apiAdmin + "/plan/" + id, {
    method: "PUT",
    headers: { "Content-Type": contentTypeJson },
    body: JSON.stringify(planInfo),
  })
    .then(handleResponse)
    .then((data) => {
      return data;
    });
};

const planCreate = function (planInfo) {
  return fetch(apiAdmin + "/plan", {
    method: "POST",
    headers: { "Content-Type": contentTypeJson },
    body: JSON.stringify(planInfo),
  })
    .then(handleResponse)
    .then((data) => {
      return data;
    });
};

const planDelete = function (id) {
  return fetch(apiPlan + "/" + id + "/delete", {
    method: "GET",
    headers: { "Content-Type": contentTypeJson },
  })
    .then(handleResponse)
    .then((data) => {
      return data;
    });
};

const oneTimePurchaseList = function (id) {
  return fetch(apiPlan + "/" + id + "/oneTimePurchase", {
    method: "GET",
    headers: { "Content-Type": contentTypeJson },
  })
    .then(handleResponse)
    .then((data) => {
      return data;
    });
};

const oneTimePurchaseCreate = function (id, body) {
  return fetch(apiAdmin + "/plan/" + id + "/oneTimePurchase", {
    method: "POST",
    headers: { "Content-Type": contentTypeJson },
    body: JSON.stringify(body),
  })
    .then(handleResponse)
    .then((data) => {
      return data;
    });
};

const whitelistForPlan = function (planId) {
  return fetch(apiAdmin + "/plan/" + planId + "/whitelist", {
    method: "GET",
    headers: { "Content-Type": contentTypeJson },
  })
    .then(handleResponse)
    .then((data) => {
      return data;
    });
};

const whitelistCreate = function (planId, body) {
  return fetch(apiAdmin + "/plan/" + planId + "/whitelist", {
    method: "POST",
    headers: { "Content-Type": contentTypeJson },
    body: JSON.stringify(body),
  })
    .then(handleResponse)
    .then((data) => {
      return data;
    });
};

const whitelistUpdate = function (planId, id, body) {
  return fetch(apiAdmin + "/plan/" + planId + "/whitelist/" + id, {
    method: "PUT",
    headers: { "Content-Type": contentTypeJson },
    body: JSON.stringify(body),
  })
    .then(handleResponse)
    .then((data) => {
      return data;
    });
};

const whitelistDelete = function (planId, id) {
  return fetch(apiAdmin + "/plan/" + planId + "/whitelist/" + id, {
    method: "DELETE",
    headers: { "Content-Type": contentTypeJson },
  })
    .then(handleResponse)
    .then((data) => {
      return data;
    });
};

const meterForPlan = function (id) {
  return fetch(apiPlan + "/" + id + "/meter", {
    method: "GET",
    headers: { "Content-Type": contentTypeJson },
  })
    .then(handleResponse)
    .then((data) => {
      return data;
    });
};

const meterEventsForReport = function () {
  return fetch(apiAdmin + "/meter/report", {
    method: "GET",
    headers: { "Content-Type": contentTypeJson },
  })
    .then(handleResponse)
    .then((data) => {
      return data;
    });
};

const meterModificationListForPlan = function (id) {
  return fetch(apiPlan + "/" + id + "/meter/events", {
    method: "GET",
    headers: { "Content-Type": contentTypeJson },
  })
    .then(handleResponse)
    .then((data) => {
      return data;
    });
};

const meterModificationCreate = function (id, body) {
  return fetch(apiAdmin + "/plan/" + id + "/meter", {
    method: "POST",
    headers: { "Content-Type": contentTypeJson },
    body: JSON.stringify(body),
  })
    .then(handleResponse)
    .then((data) => {
      return data;
    });
};

const auditLogGet = function (attrs) {
  return fetch(apiAdmin + "/auditLogs", {
    method: "POST",
    headers: { "Content-Type": contentTypeJson },
    body: JSON.stringify(attrs),
  })
    .then(handleResponse)
    .then((data) => {
      return data;
    });
};

const creditRequestList = function () {
  return fetch(apiAdmin + "/creditRequest/0", {
    method: "GET",
    headers: { "Content-Type": contentTypeJson },
  })
    .then(handleResponse)
    .then((data) => {
      return data;
    });
};

const creditRequestResolve = function (id, data) {
  return fetch(apiAdmin + "/creditRequest/" + id, {
    method: "PUT",
    headers: { "Content-Type": contentTypeJson },
    body: JSON.stringify(data),
  })
    .then(handleResponse)
    .then((dataResp) => {
      return dataResp;
    });
};

const groupList = function (planId) {
  return fetch(apiPlan + "/" + planId + "/group", {
    method: "GET",
    headers: { "Content-Type": contentTypeJson },
  })
    .then(handleResponse)
    .then((data) => {
      return data;
    });
};

const groupGet = function (id) {
  return fetch(apiGroup + "/" + id, {
    method: "GET",
    headers: { "Content-Type": contentTypeJson },
  })
    .then(handleResponse)
    .then((data) => {
      return data;
    });
};

const groupUpdate = function (id, groupInfo) {
  return fetch(apiGroup + "/" + id, {
    method: "PUT",
    headers: { "Content-Type": contentTypeJson },
    body: JSON.stringify(groupInfo),
  })
    .then(handleResponse)
    .then((data) => {
      return data;
    });
};

const groupDelete = function (id) {
  return fetch(apiGroup + "/" + id + "/delete", {
    method: "GET",
    headers: { "Content-Type": contentTypeJson },
  })
    .then(handleResponse)
    .then((data) => {
      return data;
    });
};

const projectList = function (groupId) {
  return fetch(apiGroup + "/" + groupId + "/project", {
    method: "GET",
    headers: { "Content-Type": contentTypeJson },
  })
    .then(handleResponse)
    .then((projects) => {
      return projects;
    });
};

const projectGet = function (projectId) {
  return fetch(apiProject + "/" + projectId, {
    method: "GET",
    headers: { "Content-Type": contentTypeJson },
  })
    .then(handleResponse)
    .then((project) => {
      return project;
    });
};

const projectUpdate = function (projectId, projectInfo) {
  return fetch(apiProject + "/" + projectId, {
    method: "PUT",
    headers: { "Content-Type": contentTypeJson },
    body: JSON.stringify(projectInfo),
  })
    .then(handleResponse)
    .then((data) => {
      return data;
    });
};

const projectDelete = function (id) {
  return fetch(apiProject + "/" + id + "/delete", {
    method: "GET",
    headers: { "Content-Type": contentTypeJson },
  })
    .then(handleResponse)
    .then((data) => {
      return data;
    });
};

const notificationSearch = function (searchTerm) {
  return fetch(apiNotification + "/search", {
    method: "POST",
    headers: { "Content-Type": contentTypeJson },
    body: JSON.stringify({ query: searchTerm }),
  })
    .then(handleResponse)
    .then((data) => {
      return data;
    });
};

const notificationGet = function (id) {
  return fetch(apiNotification + "/" + id, {
    method: "GET",
    headers: { "Content-Type": contentTypeJson },
  })
    .then(handleResponse)
    .then((data) => {
      return data;
    });
};

const notificationUpdate = function (id, notificationInfo) {
  return fetch(apiNotification + "/" + id, {
    method: "PUT",
    headers: { "Content-Type": contentTypeJson },
    body: JSON.stringify(notificationInfo),
  })
    .then(handleResponse)
    .then((data) => {
      return data;
    });
};

const notificationCreate = function (notificationInfo) {
  return fetch(apiNotification, {
    method: "POST",
    headers: { "Content-Type": contentTypeJson },
    body: JSON.stringify(notificationInfo),
  })
    .then(handleResponse)
    .then((data) => {
      return data;
    });
};

const notificationDelete = function (id) {
  return fetch(apiNotification + "/" + id + "/delete", {
    method: "GET",
    headers: { "Content-Type": contentTypeJson },
  })
    .then(handleResponse)
    .then((data) => {
      return data;
    });
};

const policySearch = function (searchTerm) {
  return fetch(apiPolicy + "/search", {
    method: "POST",
    headers: { "Content-Type": contentTypeJson },
    body: JSON.stringify({ query: searchTerm }),
  })
    .then(handleResponse)
    .then((data) => {
      return data;
    });
};

const policyGet = function (id) {
  return fetch(apiPolicy + "/" + id, {
    method: "GET",
    headers: { "Content-Type": contentTypeJson },
  })
    .then(handleResponse)
    .then((data) => {
      return data;
    });
};

const planGetAttachedPolicy = function (id) {
  return fetch(apiPolicy + "/" + id + "/attachedPlan", {
    method: "GET",
    headers: { "Content-Type": contentTypeJson },
  })
    .then(handleResponse)
    .then((data) => {
      return data;
    });
};

const policyUpdate = function (id, policyInfo) {
  return fetch(apiPolicy + "/" + id, {
    method: "PUT",
    headers: { "Content-Type": contentTypeJson },
    body: JSON.stringify(policyInfo),
  })
    .then(handleResponse)
    .then((data) => {
      return data;
    });
};

const policyCreate = function (policyInfo) {
  return fetch(apiPolicy, {
    method: "POST",
    headers: { "Content-Type": contentTypeJson },
    body: JSON.stringify(policyInfo),
  })
    .then(handleResponse)
    .then((data) => {
      return data;
    });
};

const policyDelete = function (id) {
  return fetch(apiPolicy + "/" + id + "/delete", {
    method: "GET",
    headers: { "Content-Type": contentTypeJson },
  })
    .then(handleResponse)
    .then((data) => {
      return data;
    });
};

const moduleList = function () {
  return fetch(apiPolicy + "/module", {
    method: "GET",
    headers: { "Content-Type": contentTypeJson },
  })
    .then(handleResponse)
    .then((data) => {
      return data;
    });
};

const functionList = function () {
  return fetch(apiPolicy + "/function", {
    method: "GET",
    headers: { "Content-Type": contentTypeJson },
  })
    .then(handleResponse)
    .then((data) => {
      return data;
    });
};

const meterForGroup = function (id) {
  return fetch(apiGroup + "/" + id + "/meter", {
    method: "GET",
    headers: { "Content-Type": contentTypeJson },
  })
    .then(handleResponse)
    .then((data) => {
      return data;
    });
};

const meterModificationListForGroup = function (id) {
  return fetch(apiGroup + "/" + id + "/meter/events", {
    method: "GET",
    headers: { "Content-Type": contentTypeJson },
  })
    .then(handleResponse)
    .then((data) => {
      return data;
    });
};

const transferCredits = function (planId, groupId, count, message) {
  return fetch(apiPlan + "/" + planId + "/credits", {
    method: "POST",
    headers: { "Content-Type": contentTypeJson },
    body: JSON.stringify({
      count: count,
      groupId: groupId,
      message: message,
    }),
  })
    .then(handleResponse)
    .then((data) => {
      return data;
    });
};

const handleResponse = function (resp) {
  return resp.text().then((text) => {
    let data;
    try {
      data = text && JSON.parse(text);
    } catch (e) {
      data = e;
    }
    if (!resp.ok) {
      if (resp.status === 503) {
        localStorage.removeItem("user");
        location.replace("/maintenance");
      }

      if (resp.status === 403) {
        localStorage.removeItem("user");
        location.replace("/login");
      }

      const err = (data && data.message) || resp.statusText;
      return Promise.reject(err);
    }

    return data;
  });
};

const token = function () {
  const requestOptions = {
    method: "GET",
    headers: { "Content-Type": contentTypeJson },
    mode: "cors",
  };

  return fetch(apiAdmin + "/adminUrl", requestOptions)
    .then(handleResponse)
    .then((res) => {
      return res;
    });
};

export const adminService = {
  fakeData,
  userSearch,
  userGet,
  userUpdate,
  userDelete,
  planSearch,
  planGet,
  planGetForOuter,
  planUpdate,
  planCreate,
  planDelete,
  oneTimePurchaseList,
  oneTimePurchaseCreate,
  meterForPlan,
  meterEventsForReport,
  meterModificationListForPlan,
  meterModificationCreate,
  whitelistCreate,
  whitelistDelete,
  whitelistForPlan,
  whitelistUpdate,
  auditLogGet,
  creditRequestList,
  creditRequestResolve,
  groupList,
  groupGet,
  groupUpdate,
  groupDelete,
  projectList,
  projectGet,
  projectUpdate,
  projectDelete,
  notificationSearch,
  notificationGet,
  notificationUpdate,
  notificationCreate,
  notificationDelete,
  policySearch,
  policyGet,
  planGetAttachedPolicy,
  policyUpdate,
  policyCreate,
  policyDelete,
  moduleList,
  functionList,
  meterForGroup,
  meterModificationListForGroup,
  transferCredits,
  token,
};
